module.exports = __webpack_public_path__ + "baa31dac964434b1c68a174950ce7e37.png";


//////////////////
// WEBPACK FOOTER
// /src/public/logo-small.png
// module id = 1994
// module chunks = 0